import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";

const deleteRoomSystem = async (id: string): Promise<void> => {
  const response = await axiosClient.delete(`/room-systems/${id}`);
  return response.data;
};

export function useDeleteRoomSystem(
  queryOptions?: UseMutationOptions<void, HttpError, { id: string }>,
) {
  return useMutation({
    mutationFn: ({ id }) => deleteRoomSystem(id),
    ...queryOptions,
  });
}
